import http from '../http.js';
import axios from 'axios'
/**
 * 获取设备属性
 * @param params
 * @return {*}
 */
export function MachineAttributeSrv(params) {
  params = params ||''
  let url = '/product/queryMachineAttribute'
  return http.post(url,params)
}
/**
 * 我要求购发布求购
 * @param params
 * @return {*}
 */
export function publishBuySrv(params) {
  let url = '/purchaseOrder/createPurchaseOrder'
  return http.post(url,params)
}

/**
 * 删除文件
 * @param params
 * @return {*}
 */
export function delateFileSrv(params){
  let url = ''
}
/**
 * 上传文件
 * @return {*}
 */
export function uploadFilesSrv() {
  return axios.defaults.baseURL + '/file/uploadMaterial'
}

export function deleteFileSrv(params) {
  let url = '/file/deleteFile';
  return http.post(url,params)
}



// WEBPACK FOOTER //
// ./src/api/askToBuy/askToBuy.js